module.exports = __webpack_public_path__ + "static/1-ab8c12fc616db4f1589097ff7e8d773d.jpeg";